import Cookies from 'universal-cookie'

const cookies = new Cookies();

export const authHeader = {Authorization: `Bearer ${cookies.get('auth_token')}`};

export const authUserId = cookies.get('user_id');

export const authUserUtmSource = cookies.get('partner_utm_source');

export const authUserUtmMedium = cookies.get('partner_utm_medium');

export const range = (start, end) => {
  return (new Array(end - start + 1)).fill(undefined).map((_, i) => i + start);
}

export const formatDate = (date) => {
  let month = '' + (date.getMonth() + 1);
  let day = '' + date.getDate();
  let year = date.getFullYear();

  if (month.length < 2)
      month = '0' + month;
  if (day.length < 2)
      day = '0' + day;

  return [year, month, day].join('-');
}
